<template>
	<div class="customer-profile-details">
		<base-header class="pb-6">
			<b-row align-v="center" class="py-2">
				<b-col md="2" lg="2" cols="auto">
					<button @click="goBack" class="btn btn-link text-primary p-0" style="text-decoration: none;">
						<b-icon icon="chevron-left"></b-icon>
						Back To List
					</button>
				</b-col>
				<b-col md="10" lg="10" cols="auto" class="text-right">
					<div class="header-assign-to-buttons">
						<!-- <b-button-group class="mx-2">
							<b-button size="sm" variant="outline-light">Credit Officer</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'loan_officer_name','-') }}</b-button>
						</b-button-group>
						
						<b-button-group class="mx-2"  v-if="!isAppeal">
							<b-button size="sm" variant="outline-light">Credit Manager</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'credit_manager_name','-') }}</b-button>
						</b-button-group>
						<b-button-group class="mx-2"  v-else>
							<b-button size="sm" variant="outline-light">Credit Head</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'credit_head_name','-') }}</b-button>
						</b-button-group> -->
						
						<!-- <b-button-group class="mx-2">
							<b-button size="sm" variant="outline-light">SSE</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'sse_name','-') }}</b-button>
						</b-button-group> -->
						
						<b-button-group class="mx-2">
							<b-button size="sm" variant="outline-light">SSA</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'ssa_name','-') }}</b-button>
						</b-button-group>
						
						<b-button-group class="mx-2">
							<b-button size="sm" variant="outline-light">SE</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'se_name','-') }}</b-button>
						</b-button-group>

						<el-dropdown trigger="click" style="cursor: pointer;">
							<p class="el-dropdown-link top-line">
								<b-icon icon="three-dots-vertical"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<div style="max-height: 300px;overflow-y: auto;">
									<span @click="$refs.drawer_call_log.viewCallLogDrawer()"
										v-if="active_tab != 'loan_eligibility_calculator'">
										<el-dropdown-item>
											<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
												<path fill="#13663E"
													d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
											</svg>
											View Call Log
										</el-dropdown-item>
									</span>
									<span @click="$refs.drawer_call_log.viewCallLogDrawer()"
										v-if="active_tab == 'loan_eligibility_calculator' && credit_manager == 0">
										<el-dropdown-item>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 384 512">
												<path fill="#DF3030"
													d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z" />
											</svg>
											<span>
												Reject Case
											</span>
										</el-dropdown-item>
									</span>
									<span @click="$refs.drawer_activity_log.show()">
										<el-dropdown-item>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
												<path fill="#13663E"
													d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
											</svg>
											View Activity Log
										</el-dropdown-item>
									</span>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</b-col>
			</b-row>
		</base-header>

		<b-container fluid class="mt--6">
			<b-row>
				<b-col cols="12" lg="3">
					<CustomerBiodata />
					<!-- <LivingCommitment /> -->
				</b-col>
				<b-col cols="12" lg="9">
					<el-tabs v-model="active_tab">
						<el-tab-pane label="Cases" name="cases">
							<TabCases />
						</el-tab-pane>

						<!-- <el-tab-pane label="Settlement" name="settlement">
							<TabSettlement />
						</el-tab-pane> -->

						<!-- <el-tab-pane
							v-if="activeCustomerInv.status !== 'Pending Approval' && activeCustomerInv.status !== 'Pending Proposal'"
							label="Proposal" name="proposal">
							<TabProposal />
						</el-tab-pane> -->
					</el-tabs>
				</b-col>
			</b-row>
		</b-container>

		<DrawerCallLog ref="drawer_call_log" />
		<DrawerActivityLog ref="drawer_activity_log" :tags="'#customer_'+_gHlp.getValue(activeLoanEC,'id')" />

	</div>
</template>
<script>
import CustomerBiodata from '@/views/CustomerProfile/LeftComponents/CustomerBiodata'

import TabCases from '@/views/CustomerProfile/CenterComponents/Cases/TabCases'
import TabSettlement from '@/views/CustomerProfile/CenterComponents/Settlement/TabSettlement'
// import TabProposal from '@/views/CustomerProfile/CenterComponents/Proposal/TabProposal'

import { Tabs, TabPane, Alert, Button, Dropdown, DropdownMenu, DropdownItem, Link, Option, Select } from 'element-ui'
import DrawerCallLog from '@/views/Call/DrawerCallLog'
import DrawerActivityLog from '@/views/CustomerProfile/Drawers/DrawerActivityLog/ActivityLog'

import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
	components: {
		CustomerBiodata,
		TabCases,
		TabSettlement,
		// TabProposal,
		DrawerCallLog,
		DrawerActivityLog,
		[Link.name]: Link,
		[Tabs.name]: Tabs,
		[Alert.name]: Alert,
		[TabPane.name]: TabPane,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomerInv', 'activeCustomer','activeLoanEC']),
		...mapState(useCreditReportStore, ['activeCreditReport']),
		enabledLoanEC() {
			return (!_gHlp.isEmpty(this.activeCustomer) && this.activeCustomer?.checklist?.has_net_income);
		},
		isAppeal(){
			return (!_gHlp.isEmpty(this.activeLoanEC) && !_gHlp.isEmpty(this.activeLoanEC.rejected_at));
		},
		isViewOnly(){
			if (!_gHlp.isEmpty(this.activeLoanEC) && (['Pending Submission','Rejected'].includes(this.activeLoanEC.status) || !_gHlp.isEmpty(this.activeLoanEC.status))){
				return false
			}else if((this.activeLoanEC.status != 'Approved')&& _gAuth.hasAccess(['role_credit_heads','role_credit_manager','role_admin','role_super_admin','role_admin_support'])){
				return false
			} else {
				return true
			}
		},

	},
	data() {
		return {
			active_tab: 'cases',
			credit_manager: 0,
		};
	},
	created() {
		_gHlp.setLoading('fetch_customer')
		// _gHlp.setLoading('fetch_loan_ec')
		// _gHlp.setLoading('fetch_credit_report')
		if (_gHlp.isEmpty(this.activeCustomer)) {
			let cust_id = this.$route.params.cust_id;
			if(_gHlp.isEmpty(cust_id)){
				this.$router.push('/customers-list/all-customer')
			}else{
				this.getCustomer(cust_id).then(resp => {
					// this.initPage();
					_gHlp.removeLoading('fetch_customer')
				}).catch(err => {
					_gHlp.removeLoading('fetch_customer')
				});
			}
		} else {
			// this.initPage();
			_gHlp.removeLoading('fetch_customer')
		}
	},
	beforeUnmount(){
		this.clearCreditReportState();
		this.clearCustomerState();
		this.clearLoanEcState();
	},
	beforeDestroy() {
		this.clearCreditReportState();
		this.clearCustomerState();
		this.clearLoanEcState();
	},
	methods: {
		...mapActions(useCustomerStore, [
			'getCustomer',
      'getLoanEC',
			'setFormLoanEc',
			'clearCustomerState',
			'clearLoanEcState',
    ]),
		...mapActions(useCreditReportStore, ['getCreditReport','clearCreditReportState']),
		goBack() {
			this.$router.back()
		},
		initPage(refresh = false) {
			this.setFormLoanEc()
			if (refresh) {
				//FETCH CUSTOMER
			}
			this.getLoanEC().then(resp => {
				_gHlp.removeLoading('fetch_loan_ec')
				_gHlp.setLoading('init_tab_loan_eligible')
			}).catch(err=>{
				_gHlp.removeLoading('fetch_loan_ec')
			})

			this.getCreditReport().then(resp => {
				_gHlp.removeLoading('fetch_credit_report')
			}).catch(err=>{
				_gHlp.removeLoading('fetch_credit_report')
			})
		},
		submitCreditManager() {
			this.credit_manager = 1
		},
		changeTab(tab) {
			this.active_tab = tab;
		},
   
	}
}

</script>
